import Timeline from '../components/timeline/Timeline';

export default function Experience() {
  return (
    <section>
      <div className="anchor" id="experience"></div>
      <div className="row center-xs start-md">
        <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 col-sm-12">
          <div className="card">
            <h2>Experience</h2>
            <Timeline />
          </div>
        </div>
      </div>
    </section>
  );
}